import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'solid';
}
/**
 * Reusable Badge component with consistent green styling
 * Used for section labels across the site
 *
 * @example
 * <Badge>Dashboard Features</Badge>
 * <Badge variant="solid">New Feature</Badge>
 */
export function Badge({
  children,
  className = '',
  variant = 'default'
}: BadgeProps) {
  const baseStyles = 'inline-flex items-center gap-2 px-4 py-2 rounded-full backdrop-blur-sm';
  const variantStyles = {
    default: 'bg-[#3ab795]/10 border border-[#3ab795]/20',
    solid: 'bg-[#3ab795] border border-[#3ab795]'
  };
  const textColor = variant === 'solid' ? 'text-white' : 'text-[#3ab795]';
  return <div className={`${baseStyles} ${variantStyles[variant]} ${className}`} data-id="element-2153">
      <div className="w-2 h-2 rounded-full bg-[#3ab795] animate-pulse" data-id="element-2154" />
      <p className={`text-sm md:text-base font-medium ${textColor} tracking-wide uppercase`} data-id="element-2155">
        {children}
      </p>
    </div>;
}